import axios from 'axios'
import { useAuthStore } from '@/store/auth'

const httpFunctionsAccounts = axios.create({
  baseURL: import.meta.env.VITE_FUNCTIONS_ACCOUNTS_API,
  headers: {},
  timeout: 30000
})
const httpFunctionsValueHypo = axios.create({
  baseURL: import.meta.env.VITE_FUNCTIONS_VALUEHYPO_API,
  headers: {},
  timeout: 30000
})

const httpNaxos = axios.create({
  baseURL: import.meta.env.VITE_NAXOS_API,
  headers: {},
  timeout: 30000
})

httpNaxos.interceptors.request.use(config => {
  const authStore = useAuthStore()
  const uid = authStore?.userData?.uid
  if (!uid) {
    throw new Error('Syft-User-Id unavailable: auth store has no uid; httpNaxos called pre-auth')
  }
  config.headers['Syft-User-Id'] = uid
  return config
})

const httpFunctionsValidatedContext = axios.create({
  baseURL: import.meta.env.VITE_FUNCTIONS_VALIDATED_CONTEXT_API,
  headers: {},
  timeout: 30000
})

const httpFunctionsHitSummary = axios.create({
  baseURL: import.meta.env.VITE_FUNCTIONS_HIT_SUMMARY_API,
  headers: {},
  timeout: 30000
})

const httpFunctionsProcessedData = axios.create({
  baseURL: import.meta.env.VITE_FUNCTIONS_PROCESSED_DATA_API,
  headers: {},
  timeout: 30000
})

const httpFunctionsCreteInference = axios.create({
  baseURL: import.meta.env.VITE_FUNCTIONS_CRETE_INFERENCE_API,
  headers: {},
  timeout: 30000
})

const httpFunctionsAccountAISummary = axios.create({
  baseURL: import.meta.env.VITE_FUNCTIONS_ACCOUNT_AI_SUMMARY_API,
  headers: {},
  timeout: 30000
})
const httpFunctions = axios.create({
  baseURL: import.meta.env.VITE_CLOUD_FUNCTIONS_API,
  headers: {},
  timeout: 30000
})

const httpKalamata = axios.create({
  baseURL: import.meta.env.VITE_FUNCTIONS_KALAMATA_API,
  headers: {},
  timeout: 30000
})

const httpAthens = axios.create({
  baseURL: import.meta.env.VITE_FUNCTIONS_ATHENS_API,
  headers: {},
  timeout: 30000
})

const httpClio = axios.create({
  baseURL: import.meta.env.VITE_FUNCTIONS_CLIO_API,
  headers: {},
  timeout: 30000
})

const httpMidasDispatcher = axios.create({
  baseURL: import.meta.env.VITE_MIDAS_DISPATCHER_API,
  headers: {},
  timeout: 30000
})

// Hydra JWT generator endpoint
const httpHydra = axios.create({
  baseURL: import.meta.env.VITE_HYDRA_JWT_ENDPOINT,
  headers: {},
  timeout: 30000
})

const httpFunctionsUpload = axios.create({
  baseURL: import.meta.env.VITE_FUNCTIONS_UPLOADER,
  headers: {},
  timeout: 0
})

// Analytics Relay requires explicit Bearer token authentication
const httpFunctionsAnalytics = axios.create({
  baseURL: import.meta.env.VITE_FUNCTIONS_ANALYTICS_RELAY,
  headers: {},
  timeout: 30000
})

const httpFunctionsMetabaseReporting = axios.create({
  baseURL: import.meta.env.VITE_FUNCTIONS_METABASE_REPORTING,
  headers: {},
  timeout: 30000
})

export {
  httpFunctionsAccounts,
  httpFunctionsValueHypo,
  httpNaxos,
  httpFunctionsHitSummary,
  httpFunctionsProcessedData,
  httpFunctionsCreteInference,
  httpFunctionsValidatedContext,
  httpFunctionsAccountAISummary,
  httpFunctions,
  httpKalamata,
  httpAthens,
  httpClio,
  httpMidasDispatcher,
  httpHydra,
  httpFunctionsUpload,
  httpFunctionsAnalytics,
  httpFunctionsMetabaseReporting
}
